import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Building2 } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Shown when a company admin tries to access company features.
 * Cleaning company dashboards and invites have been removed; only owner-managed properties and token-gated cleaner portals are supported.
 */
export default function CompanyUnavailable() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-muted/30">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building2 className="w-5 h-5" />
            Company features no longer available
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Cleaning company dashboards and company-based cleaner assignment have been discontinued.
            Property owners now manage cleaners via a &quot;Cleaner Access&quot; link (token) in each property&apos;s Settings.
          </p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
